/* Light YouTube Embeds by */
/* Web: http://labnol.org/?p=27941 */

export default class YoutubePlayer {

  init() {
    const getThumbnail = this.getThumbnail.bind(this);
    const createIframe = this.createIframe.bind(this);
    let div;
    let n;
    const v = document.getElementsByClassName('youtube-player');
    for (n = 0; n < v.length; n += 1) {
      div = document.createElement('div');
      div.setAttribute('data-id', v[n].dataset.id);
      div.innerHTML = getThumbnail(v[n].dataset.id);

      div.addEventListener('click', function () {
        createIframe(this);
      });

      v[n].appendChild(div);
    }
  }

  getThumbnail(id) {
    const thumb = '<img src="https://i.ytimg.com/vi/ID/hqdefault.jpg">';
    const play = '<div class="play"></div>';
    return thumb.replace('ID', id) + play;
  }

  createIframe(obj) {
    const iframe = document.createElement('iframe');
    const embed = 'https://www.youtube.com/embed/ID?autoplay=1';
    iframe.setAttribute('src', embed.replace('ID', obj.getAttribute('data-id')));
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allowfullscreen', '1');
    obj.replaceChild(iframe, obj.childNodes[0]);
  }

}



// WEBPACK FOOTER //
// ./homepage/scripts/components/youtube-player.js